module.exports = __webpack_public_path__ + "img/bridge4.41401305.png";